/* eslint-disable ember/no-new-mixins */
import Mixin from '@ember/object/mixin';
import { action } from '@ember/object';

export default Mixin.create({
  postBeingEdited: null,
  editingPost: false,

  newPost: action(function (page) {
    // Ensure that no post is selected for editing before triggering the popup.
    this.set('postBeingEdited', null);
    if (page) {
      this.set('selectedPage', page);
    } else {
      this.set('selectedPage', null);
    }
    this.set('editingPost', true);
  }),

  editPost: action(function (post) {
    this.set('editingPost', true);
    this.set('postBeingEdited', post);
  }),

  closeEditPost: action(function () {
    this.set('editingPost', false);
    this.set('postBeingEdited', null);
  }),
});
